window.localStorageKey = 'apex';

export {};
